import React, { useEffect, useState } from "react";
import { formateDateTime } from "../../utils";
import Avatar from "../../static/images/avata.svg";
import { ChatEvents, MessageType, Roles } from "../../constants";
import { createImageFromInitials } from "../../AgentLogo";
import FileIcon from "../../static/images/icon-file.svg";
import DownloadIcon from "../../static/images/icon-download.svg";
import ReplyIcon from "../../static/images/Reply.svg";
import Ticket from "./chatElements/ticket";
import { CardSelection, CustomCardSingle, SelectionList, SingleCardSelection } from "./chatElements/CustomCard";
import Document from "./chatElements/document";
import CallBackSelection from "./chatElements/CallBackSelection";

const scrollToMessage = (replyId) => {
    if (!replyId) return;
    setTimeout(() => {
        const element = document.getElementById(replyId);
        if (element) {
            element.classList.add("highlight-message");

            setTimeout(() => {
                element.classList.remove("highlight-message");
            }, 500);

            element.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
            console.warn("No element found for id:", replyId);
        }

    }, 100);
};

function JsonTemplate({
    message,
    displayAllOptions,
    GAEvent,
    showPlansComparison,
    regenDoc,
    selectOption,
    contactSupport,
    mainMenu,
    ViewPlanDetails,
    scrollToBottom,
    isHistoryMessgage,
    agentName,
    AgentMsg,
    index,
    scrollintoview,
    id,
    lastMessage,
    setAgentMsgReplied,
    roomId
}) {

    const [countItem, setCountItem] = useState(0);
    const [varCounter, setVarCounter] = useState(0);
    const [autoOpen, setAutoOpen] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setCountItem(countItem + 1);
        }, 100);
        // scrollToBottom()
        return () => clearInterval(interval);

    }, []);

    useEffect(() => {
        if (lastMessage.messageId == message.messageId) {
            if (lastMessage.content) {
                const content = JSON.parse(lastMessage.content);
                if (content.title && content?.title.length < 200 && content.choices.length <= 6) {
                    setAutoOpen(true);
                }
            }
        } else {
            setAutoOpen(false);
        }
    }, [lastMessage]);

    // const varName = () => {
    //     console.log(countItem)
    //     console.log(varCounter)
    //     if (varCounter <= countItem) {
    //         setVarCounter(prevCounter => prevCounter + 1);
    //         console.log("111111111111111")
    //         const $cards = document.querySelectorAll('.product-info .card-item ');
    //         if ($cards[varCounter - 1]) {
    //             $cards[varCounter - 1].classList.add('hidden');
    //             setTimeout(() => {
    //                 $cards[varCounter - 1].classList.add('show');
    //             }, varCounter * 1000);
    //         }
    //     }
    // };

    // useEffect(() => {
    //     const $cards = document.querySelectorAll('.product-info .card-item ');
    //     setCountItem(4);
    // }, []);

    const [viewMore, setViewMore] = useState(false)
    const content = JSON.parse(message.content);
    useEffect(() => {
        if (content.choices && content.choices.length > 2 && !message.selected) {
            setViewMore(true)
        }
    })
    useEffect(() => {
        if (content && content.type === "TicketSelection") {
            if (content.choices && content.choices.length > 1) {
                GAEvent({eventAction:"previous-ticket",eventLabel: "multiple"})
            }
            else {
                GAEvent({eventAction:"previous-ticket",eventLabel: "single"})
            }
        }
    }, [content])
    const [count, setCount] = useState(-1);
    useEffect(() => {
        // if (content.type && content.type != "BookingSelection" && !message.selected) {


            if (message.selected || agentName || id!=lastMessage.messageId) {
                setCount(9999)
            }
            else if (content.choices && content.choices.length > count) {

                const interval = setInterval(() => {
                    setCount(count + 1);
                }, 500);
                // scrollToBottom(id)
                if (!message.selected && !agentName && content.type && content.type != "BookingSelection") {
                scrollintoview(id)
                }
                else{ 
                    scrollToBottom()
                }
                return () => clearInterval(interval);
            }
        // }
    }, [count, message.displayAllOptions, viewMore]);

    let refMsgContent = null;
    let refMsgRole = null;
    let refMessageId = null;
    if (content.refMsgContent) {
        refMsgContent = content.refMsgContent;
        refMsgRole = refMsgContent.role;
        refMessageId = refMsgContent.messageId;
        if (refMsgContent.type === MessageType.json) {
            refMsgContent = JSON.parse(refMsgContent.content)
        } else {
            refMsgContent = refMsgContent.content;
        }
    }
    return (
        <div id={message.messageId}>
            {content.type && content.type.toLowerCase() === MessageType.document ?
                <div className="grop_message">
                    <div className="agent-message-replied">
                        <div onClick={() => regenDoc(content.document.docId)} className="download-policy-message message">
                            <div className="download-policy">
                                <img src={FileIcon} className="icon-file" alt="" /><p>Document</p><img src={DownloadIcon} className="icon-download" alt="" />
                            </div>

                        </div>
                        {message.roomId == roomId ? 
                        <div className='agentMsgReplyIcon' onClick={() => setAgentMsgReplied(message)}>
                            <img src={ReplyIcon} alt="reply" />
                        </div> : null}
                    </div>
                </div>
                : null}
                

            {content.type && content.type.toLowerCase() === "selection" ?
                <>
                    {content.title ? (
                        <>
                            <div class="grop_message">
                                <div
                                    class="message"
                                    dangerouslySetInnerHTML={{ __html: content.title }}
                                />
                            </div>
                            {/* <>
                                <img class="grop_message blank" >
                                </img>
                                <div class=" grop_message msg-detials">
                                    PB Chat <i />{formateDateTime(message.sentAt)}
                                </div>
                            </> */}

                        </>
                    ) : null}
                    {message.selected || isHistoryMessgage ? null : (
                        <>
                            <div class="mcq">
                                {content.choices.map((item1, index) => (
                                    <>
                                        {index <= count ?
                                            <>
                                                {message.displayAllOptions || index < 9999 || !viewMore ?
                                                    <button disabled={agentName ? true : false} onClick={() => selectOption(item1, content.type, message.messageId)} class="question">
                                                        {item1.display_value}{ }
                                                    </button>
                                                    : null}
                                            </> : <>
                                                {index === count + 1 ?
                                                    <div class="grop_message">
                                                        {/* <div class="message"> */}

                                                        <div class="stage">
                                                            <div class="dot-typing"></div>
                                                            {/* </div> */}
                                                        </div>
                                                    </div>
                                                    : null
                                                }
                                            </>
                                        }

                                    </>
                                ))}
                                {viewMore && (content.choices).length >= 9999 && !message.displayAllOptions ?
                                    <button onClick={() => displayAllOptions(message.messageId)} class="question">
                                        {"View More"}
                                    </button>
                                    : null}
                            </div>
                        </>
                    )}
                </>
                : null}
            {content.type && content.type === "BookingSelection" ?
                <CardSelection
                    GAEvent={GAEvent}
                    message={message}
                    selectOption={selectOption}
                    displayAllOptions={displayAllOptions}
                    scrollToBottom={scrollToBottom}
                    isHistoryMessgage={isHistoryMessgage}
                    agentName={agentName}
                    scrollintoview={scrollintoview}
                    id={id}
                />
                : null}

            {content.type && (content.type === "selectionList" ) ?
                <SelectionList
                    GAEvent={GAEvent}
                    message={message}
                    displayAllOptions={displayAllOptions}
                    autoOpen={false}
                    selectOption = {selectOption}
                    isHistoryMessgage={isHistoryMessgage}
                    agentName={agentName}
                    id={id}
                />
                : null}

            {content.type && content.type === "SingleBooking" ?
                <SingleCardSelection
                    GAEvent={GAEvent}
                    message={message}
                    displayAllOptions={displayAllOptions}
                />
                : null}
            {content.type && content.type === "CallBackSelection" ?
                <CallBackSelection
                    GAEvent={GAEvent}
                    message={message}
                    selectOption={selectOption}
                    displayAllOptions={displayAllOptions}
                    scrollToBottom={scrollToBottom}
                    isHistoryMessgage={isHistoryMessgage}
                    agentName={agentName}
                    scrollintoview={scrollintoview}
                    id={id}
                />
                : null}
            {content.type && content.type === "TicketSelection" ?
                <>
                    {content.title ? (
                        <>
                            <div class="grop_message">
                                <div
                                    class="message"
                                    dangerouslySetInnerHTML={{ __html: content.title }}
                                />
                            </div>
                            {/* <img class="grop_message blank" >
                            </img>
                            <div class=" grop_message msg-detials">
                                PB Chat <i /> {formateDateTime(message.sentAt)}
                            </div> */}
                        </>
                    ) : null}

                    {message.selected || isHistoryMessgage ? null : (
                        <>



                            <div class={`product-info ${agentName ? "disable" : null}`}>

                                {content.choices.map((item1, index) => (
                                    <>{index <= count ?
                                        <>
                                            {message.displayAllOptions || index < 2 || !viewMore ?
                                                <>
                                                    {item1.display_value === "Another Query" ? null :
                                                        <div className="" onClick={() => selectOption(item1, content.type, message.messageId)}>
                                                            <Ticket
                                                                GAEvent={GAEvent}
                                                                ticketId={item1.display_value}
                                                                regarding={item1.display_discription}
                                                                ticketResolution={{
                                                                    text: item1.ref_key,
                                                                    value: item1.ref_value
                                                                }}
                                                            />
                                                        </div>
                                                    }
                                                </>
                                                :
                                                null}

                                        </>
                                        : <>
                                            {index === count + 1 && count < 2 ?
                                                <div class="grop_message">
                                                    {/* <div class="message"> */}

                                                    <div class="stage">
                                                        <div class="dot-typing"></div>
                                                        {/* </div> */}
                                                    </div>
                                                </div>
                                                : null
                                            }
                                        </>
                                    }
                                    </>
                                ))}
                                {viewMore && !message.displayAllOptions && count > 2 && (content.choices.length - 3 > 0) ?
                                    <div className="ticket msg" onClick={() => displayAllOptions(message.messageId)}>
                                        {`+${content.choices.length - 3} more open requests`}
                                    </div>
                                    : null}
                                {/* {count > 3 ? */}
                                <>
                                    {content.choices.map((item1, index) =>
                                        <>
                                            {item1.display_value === "Another Query" ?
                                                <div className="ticket msg" onClick={() => selectOption(item1, content.type, message.messageId)}>
                                                    {item1.display_discription}
                                                    {/* <div className="ticket-body">

                                                    <span className="ticketreg">{item1.display_discription}</span>
                                                </div> */}
                                                </div>
                                                : null
                                            }
                                        </>
                                    )}
                                </>

                            </div >
                        </>
                    )}
                </>

                : null
            }

            {content.type && content.type === "PolicyCopy" ?
                <>
                    {content.title ? (
                        <div class="grop_message">
                            <div
                                class="message"
                                dangerouslySetInnerHTML={{ __html: content.title }}
                            />
                        </div>

                    ) : null}
                    {content.documents && !isHistoryMessgage ? content.documents.map((item) =>
                        <div className="grop_message">

                            <Document
                                doc_name={item.doc_name}
                                mediUrl={item.mediaUrl}
                            />

                        </div>
                    ) : null}
                    {content.choices && content.choices.length > 0 ?
                        <>
                            {message.selected || isHistoryMessgage ? null : (
                                <>
                                    <div class="mcq">
                                        {content.choices.map((item1, index) => (
                                            <>
                                                {item1 && item1.display_value ?
                                                    <button disabled={agentName ? true : false} onClick={() => selectOption(item1, content.type, message.messageId)} class="question">
                                                        {item1.display_value}
                                                    </button>
                                                    : null}
                                            </>
                                        ))}
                                        {viewMore && !message.displayAllOptions ?
                                            <button onClick={() => displayAllOptions(message.messageId)} class="question">
                                                {"View More"}
                                            </button>
                                            : null}
                                    </div>
                                </>
                            )}
                        </> : null
                    }
                </>
                : null
            }


            {content.type && content.type === "CustomerEngage" ?
                <>
                    {message.selected ? null : content.choices.map((item1, index) => (
                        <div class="grop_message tabq" key={item1.key}>
                            <button disabled={agentName ? true : false} onClick={() => selectOption(item1, "selection", message.messageId)} className="question " >
                                {item1.display_value}
                            </button>
                        </div>
                    ))}
                </>
                : null}
            {content.type && content.type === "freezeSelection" ?
                <>
                    {content.title ? (
                        <>
                            <div class="grop_message">
                                <div
                                    class="message"
                                    dangerouslySetInnerHTML={{ __html: content.title }}
                                />
                            </div>
                            {/* <>
                                <img class="grop_message blank" />

                                <div class=" grop_message msg-detials">
                                    PB Chat <i />{formateDateTime(message.sentAt)}
                                </div>
                            </> */}

                        </>
                    ) : null}
                    {isHistoryMessgage ? null :
                        <div class="mcq">
                            {content.choices.map((item1, index) => (
                                <>
                                    {index <= count ?

                                        <button disabled={agentName ? true : false} onClick={() => selectOption(item1, content.type, message.messageId)} class="question">
                                            {item1.display_value}{ }
                                        </button>
                                        : <>
                                            {index === count + 1 ?
                                                <div class="grop_message">
                                                    {/* <div class="message"> */}

                                                    <div class="stage">
                                                        <div class="dot-typing"></div>
                                                        {/* </div> */}
                                                    </div>
                                                </div>
                                                : null
                                            }
                                        </>
                                    }

                                </>
                            ))}
                        </div>
                    }
                </>
                : null}
            {content.type === 'MsgReply' && (
                <div className="grop_message" onClick={() => scrollToMessage(refMessageId)}>
                    <div className="agent-message-replied">
                        <div className="message">
                            {refMsgContent && (
                                <div className={`reply-box ${refMsgRole != "customer" ? "agent_Message" : ""}`}>
                                    {!refMsgContent.type ? (
                                        <div
                                            className="reply-message"
                                            dangerouslySetInnerHTML={{ __html: refMsgContent }}
                                        />
                                    ) : refMsgContent.type === MessageType.document ? (
                                        <div className="download-policy">
                                            <p>Document</p>
                                        </div>
                                    ) :
                                    refMsgContent.type === 'MsgReply' ? (
                                        <div className="reply-message">
                                            {refMsgContent.title}
                                        </div>)
                                    :(
                                        <div className="reply-message">
                                            {refMsgContent.display_value}
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="message-text">
                                {content.title}
                            </div>
                        </div>
                        {message.roomId == roomId ?
                        <div className='agentMsgReplyIcon' onClick={() => setAgentMsgReplied(message)}>
                            <img src={ReplyIcon} alt="reply" />
                        </div> : null}
                    </div>
                </div>
            )}
            {/* {message.type && message.type.toLowerCase() === MessageType.json ? null :
                <>
                    {index === 0 ?
                        <>
                            {message.name ?

                                <img class="grop_message tia-icon" src={createImageFromInitials(500, message.name, "blue")} />
                                :
                                <img class="grop_message tia-icon" src={Avatar} />
                            }
                        </> : <img class="grop_message blank" >
                        </img>}

                    <div class=" grop_message msg-detials">{AgentMsg ? `${message.name || null} ${message.employeeId || null}` : 'PB Chat'} <i />
                        {formateDateTime(message.sentAt)}
                    </div>
                </>
            } */}
        </div>
    );
}

export default function ServiceAgentMessage({
    messages,
    agentName,
    displayAllOptions,
    GAEvent,
    showPlansComparison,
    regenDoc,
    selectOption,
    contactSupport,
    mainMenu,
    AgentMsg,
    ViewPlanDetails,
    scrollToBottom,
    isHistoryMessgage,
    scrollintoview,
    lastMessage,
    setAgentMsgReplied,
    roomId
}) {
    console.log('------::::-----',lastMessage);
    useEffect(() => {
        setTimeout(() => {
            var query = document.querySelector(".rej-reason")
            if (query) {
                
                var addclass = function () {
                    var classlist = document.querySelector(".rej-reason")?.classList;
                    console.log(classlist)
                    if(classlist && classlist.contains("open")){
                        classlist.remove("open")
                    }
                    else{
                        classlist.add("open")
                    }
                }
                query.addEventListener('click', addclass);

            }
        }, 100)
    }, [])
    
    const replaceURLWithHTMLLinks = (item) => {
        if (item.role === "agent") {
            const urlRegex = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/g;
            return item.content.replace(urlRegex, function (url) {
                if (url.match(/^https?:\/\//)) {
                    return '<a href="' + url + '" target="_blank" class="chat-link">' + url + '</a>';
                } else {
                    return '<a href="http://' + url + '" target="_blank" class="chat-link">' + url + '</a>';
                }
            });
        }
        else {
            return item.content;
        }
    }

    return (
        <li class="you">
            <>
                {messages[messages.length - 1].name ?

                    <img class="grop_message tia-icon" src={createImageFromInitials(500, messages[messages.length - 1].name, "blue")} />
                    :
                    <img class="grop_message tia-icon" src={Avatar} />
                }

                <div class=" grop_message msg-detials">{AgentMsg ? `${messages[messages.length - 1].name || null} ${messages[messages.length - 1].employeeId || null}` : 'PB Chat'} <i />
                    {formateDateTime(messages[messages.length - 1].sentAt)}
                </div>
            </>


            {messages.map((item, index) => (
                <>
                    {item.type.toLowerCase() === "json" ? (
                        <JsonTemplate
                            message={item}
                            displayAllOptions={displayAllOptions}
                            GAEvent={GAEvent}
                            showPlansComparison={showPlansComparison}
                            regenDoc={regenDoc}
                            selectOption={selectOption}
                            contactSupport={contactSupport}
                            mainMenu={mainMenu}
                            AgentMsg={AgentMsg}
                            ViewPlanDetails={ViewPlanDetails}
                            scrollToBottom={scrollToBottom}
                            isHistoryMessgage={isHistoryMessgage}
                            agentName={agentName}
                            index={index}
                            scrollintoview={scrollintoview}
                            id={messages[messages.length - 1].messageId}
                            lastMessage={lastMessage}
                            setAgentMsgReplied={setAgentMsgReplied}
                            roomId={roomId}
                        ></JsonTemplate>
                    ) : (
                        <>

                                <div class="grop_message" id={item.messageId}>
                                    <div className="agent-message-replied">
                                        <div
                                            class={((item.content).toLowerCase().includes('policy-details')) ? 'message pb-detials' : 'message'}
                                            //    class="message pb-detials"
                                            dangerouslySetInnerHTML={{
                                                __html: replaceURLWithHTMLLinks(item),
                                            }}
                                        >
                                            {" "}
                                        </div>
                                        {item?.role?.toLowerCase() == 'agent' && item.roomId == roomId ?
                                            <div className='agentMsgReplyIcon' onClick={() => setAgentMsgReplied(item)}>
                                                <img src={ReplyIcon} alt="reply" />
                                            </div> : null}
                                    </div>
                            </div>
                            {/* {item.type && item.type.toLowerCase() === MessageType.json ? null :
                                <>
                                    {index === 0 ?
                                        <>

                                            {item.name ?

                                                <img class="grop_message tia-icon" src={createImageFromInitials(500, item.name, "blue")} />
                                                :
                                                <img class="grop_message tia-icon" src={Avatar} />
                                            }
                                        </>
                                        : <img class="grop_message blank" >
                                        </img>}

                                    <div class=" grop_message msg-detials">{AgentMsg ? `${item.name || null} ${item.employeeId || null}` : 'PB Chat'} <i />
                                        {formateDateTime(item.sentAt)}
                                    </div>
                                </>
                            } */}
                        </>
                    )}
                </>
            ))}
            {/* {messages[messages.length - 1].type && messages[messages.length - 1].type.toLowerCase() === MessageType.json ? null :
                <>
                    {messages[messages.length - 1].name ?

                        <img class="grop_message tia-icon" src={createImageFromInitials(500, messages[messages.length - 1].name, "blue")} />
                        :
                        <img class="grop_message tia-icon" src={Avatar} />
                    }

                    <div class=" grop_message msg-detials">{AgentMsg ? `${messages[messages.length - 1].name || null} ${messages[messages.length - 1].employeeId || null}` : 'PB Chat'} <i />
                        {formateDateTime(messages[messages.length - 1].sentAt)}
                    </div>
                </>
            } */}
        </li>
    );
}
